/* cl-countdown.js — the one countdown for the campaign sections.
 *
 * Lifted out of cl-campaign-hero.liquid (round one of the Black Friday page)
 * so the hero, the sticky bar and the offer stack tick the same clock from the
 * same deadline instead of carrying three copies of the loop.
 *
 * Markup contract, on any element:
 *   [data-cl-countdown data-deadline="2026-11-03T00:00:00+01:00"]
 *     [data-unit="days|hours|minutes|seconds"]   the digits (any subset)
 *     [data-cl-countdown-units]                  wrapper hidden on expiry (optional)
 *     [data-cl-countdown-fallback]               server-rendered text hidden once live (optional)
 *     [data-cl-countdown-expired hidden]         shown on expiry (optional)
 *   data-pad="0" keeps hours/minutes/seconds unpadded (default pads to 2)
 *   data-pad-days pads the days to two digits too (the BF hero clock: 02 14 36 12)
 *
 * On expiry the root gets `data-expired`, dispatches `cl:countdown-expired`
 * (bubbles) and stops. Hosts that should disappear when the clock runs out
 * listen for that event instead of polling.
 *
 * The tag is emitted once per section instance; the browser fetches the file
 * once and this guard makes every later run a scan for new roots, which is
 * also what the theme editor's section reloads need.
 */
(function () {
  if (window.clCountdown) { window.clCountdown.scan(); return; }

  var roots = [];

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setup(el) {
    if (el.dataset.clCountdownReady === '1') return;
    el.dataset.clCountdownReady = '1';
    var end = Date.parse(el.getAttribute('data-deadline') || '');
    if (isNaN(end)) return;
    var cells = {};
    Array.prototype.forEach.call(el.querySelectorAll('[data-unit]'), function (c) { cells[c.getAttribute('data-unit')] = c; });
    var state = {
      el: el, end: end, cells: cells,
      units: el.querySelector('[data-cl-countdown-units]'),
      fallback: el.querySelector('[data-cl-countdown-fallback]'),
      expired: el.querySelector('[data-cl-countdown-expired]'),
      padded: el.getAttribute('data-pad') !== '0',
      padDays: el.hasAttribute('data-pad-days'),
      done: false
    };
    roots.push(state);
    tick(state);
  }

  function tick(s) {
    if (s.done) return;
    var left = s.end - Date.now();
    if (left <= 0) {
      s.done = true;
      if (s.units) s.units.hidden = true;
      if (s.fallback) s.fallback.hidden = true;
      if (s.expired) s.expired.hidden = false;
      s.el.setAttribute('data-expired', '');
      s.el.dispatchEvent(new CustomEvent('cl:countdown-expired', { bubbles: true }));
      return;
    }
    var secs = Math.floor(left / 1000);
    var d = Math.floor(secs / 86400), h = Math.floor(secs / 3600) % 24, m = Math.floor(secs / 60) % 60, sec = secs % 60;
    // Without a days cell the hours absorb the days, so a 3-cell clock still reads right.
    if (!s.cells.days) h += d * 24;
    if (s.cells.days)    s.cells.days.textContent    = s.padDays ? pad(d) : String(d);
    if (s.cells.hours)   s.cells.hours.textContent   = s.padded ? pad(h) : String(h);
    if (s.cells.minutes) s.cells.minutes.textContent = s.padded ? pad(m) : String(m);
    if (s.cells.seconds) s.cells.seconds.textContent = s.padded ? pad(sec) : String(sec);
    if (s.fallback) s.fallback.hidden = true;
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-countdown]'), setup);
  }

  // One interval for every clock on the page: cheaper than one per section, and
  // the digits change in the same frame so two clocks never disagree by a second.
  setInterval(function () { for (var i = 0; i < roots.length; i++) tick(roots[i]); }, 1000);

  window.clCountdown = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
